import type { BrandConfig, PeriodSpec } from './types';

export const SUBSTRATE_BRAND: BrandConfig = {
  product: {
    id: 'shuttle',
    title: 'Whittle Shuttle',
    cliBinary: 'whittle-shuttle',
    packageName: '@whittlelabs/shuttle',
    version: '0.1.0',
    description: 'Substrate agent harness for Whittle Jobs job pools.',
  },
  paths: {
    configDir: '~/.shuttle',
  },
  // Dev distribution allows every executor.
  executorAllowlist: ['*'],
  keepRegistration: {
    keepApiUrl: 'http://localhost:3007',
    jobsApiUrl: 'http://localhost:3005',
    oauthClientId: 'shuttle-dev',
    orgSlug: 'whittle-labs',
    roleSlug: 'shuttle-dev',
    scopes: ['jobs:subscribe', 'jobs:submit'],
    serviceIdentityDisplayName: "{user}'s Shuttle on {hostname}",
  },
  defaultCaps: {
    dailyTokens: 1_000_000,
    monthlyTokens: 20_000_000,
  },
};

export const DEFAULT_DAILY_PERIOD: PeriodSpec = {
  kind: 'rolling',
  durationHours: 24,
};

export const DEFAULT_MONTHLY_PERIOD: PeriodSpec = {
  kind: 'rolling',
  durationHours: 24 * 30,
};

export const DEFAULT_REFUSAL_MESSAGE =
  'Spend cap exceeded for {period}: used {used} {unit} of {cap} ({remaining} {unit} remaining).';
